export function NovuIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.32 6.413C12.32 6.843 11.798 7.056 11.497 6.7485L5.338 0.453503C6.19323 0.152589 7.09338 -0.000761518 8 2.84334e-06C9.5915 2.84334e-06 11.074 0.465003 12.32 1.2655V6.413ZM14.56 3.42V6.413C14.56 8.8505 11.6005 10.0575 9.896 8.315L3.2725 1.5455C1.288 3.0015 0 5.3505 0 8C0 9.7035 0.5325 11.2825 1.44 12.58V9.603C1.44 7.1655 4.3995 5.9585 6.104 7.701L12.7185 14.461C14.708 13.006 16 10.654 16 8C16 6.2965 15.4675 4.7175 14.56 3.42ZM4.503 9.2675L10.6505 15.55C9.821 15.8415 8.929 16 8 16C6.409 16 4.926 15.535 3.68 14.7345V9.603C3.68 9.173 4.2025 8.96 4.503 9.2675Z"
        fill="currentColor"
      />
    </svg>
  );
}
